import { getLinesFromHighlight } from './getLinesFromHighlight';

export const isLineActive = (
  activeLines: Array<string | number>,
  lineNumber: number,
): boolean => {
  if (!activeLines || !activeLines.length) return false;

  const allLines: number[] = getLinesFromHighlight(activeLines);

  return allLines.some(l => l === lineNumber + 1);
};
